import React from "react";
import Dashboard from "./components/Dashboard";
import "./DashboardApp.css";
import HeaderMain from "../dasboard-component/Components/HeaderMain";

const UserDashboardApp = () => {
  return (
    <div className="App">
      <HeaderMain pageType="user-fitness-stats" />
      <Dashboard />
    </div>
  );
};

export default UserDashboardApp;
